import {
  REQUIRE_MISSING_ITEM_REQUEST,
  REQUIRE_MISSING_ITEM_SUCCESS,
  REQUIRE_MISSING_ITEM_FAILURE,
} from '../../constants/action-types';

const getInitialState = () => {
  return {
    isLoading: false,
    error: false,
  };
};

const initialState = getInitialState();

const requireMissingItem = (state = initialState, action) => {
  const types = {
    [REQUIRE_MISSING_ITEM_REQUEST]: () => ({
      ...state,
      isLoading: true,
    }),
    [REQUIRE_MISSING_ITEM_SUCCESS]: () => ({
      ...state,
      isLoading: false,
      error: false,
    }),
    [REQUIRE_MISSING_ITEM_FAILURE]: () => ({
      ...state,
      isLoading: false,
      error: true,
      message: action.message,
    }),
  };

  if (!types[action.type]) {
    return state;
  }

  return types[action.type]();
};

export default requireMissingItem;
